// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3aQIu","cell":"ColumnAccessor_cell__1ptAC","firstCellAccent":"ColumnAccessor_firstCellAccent__1mLj5"};